import { thunkProgress } from 'redux-progress';
import type { Dispatch, GetState } from 'model/State';
import { FETCH_DC_APP_PARENT_MAPPING_BY_PARTNER } from './types';
import { fetchDcAppParentMappingByPartner } from '../../api';
import { downloadDcAppParentMappingCSV } from 'util/mac/downloadCSV';

/**
 * Action to fetch DC App Parent Mapping for a given partner and download as CSV
 * On success, automatically downloads a CSV file with columns: app_account_id, parent_account_id
 * @param partnerId - The partner ID to fetch mappings for
 */
export const fetchDcAppParentMapping =
  (partnerId: string) => (dispatch: Dispatch, getState: GetState) => {
    if (!partnerId) return;

    const state = getState();
    const fetchPromise = fetchDcAppParentMappingByPartner(partnerId, state).then((result) => {
      if (result && Array.isArray(result)) {
        downloadDcAppParentMappingCSV(result, partnerId);
      }
      return result;
    });

    dispatch(
      thunkProgress(FETCH_DC_APP_PARENT_MAPPING_BY_PARTNER, fetchPromise, {
        partnerId,
      }),
    );
  };
